<template>
  <div class="channel-modal" v-show="value">
    <div class="close" @click="click_close">X</div>

    <div class="content" v-html="ruler">
    </div>
    <div class="channel_box">
      <div class="title">
        <div class="line"></div>
        <span>请选择支付方式</span>
        <div class="line"></div>
      </div>
      <div class="channels" v-if="channels.length===2">
        <div class="channel_item" @click="click_channel(channels[0].channel)">
          <img :src="channels[0].icon" class="channel"/>
          <div>{{channels[0].name}}</div>
        </div>
        <div class="channel_item" @click="click_channel(channels[1].channel)">
          <img :src="channels[1].icon" class="channel"/>
          <div>{{channels[1].name}}</div>
        </div>
      </div>

      <div class="single_channel" v-if="channels.length===1">
        <div class="channel_item" @click="click_channel(channels[0].channel)">
          <img :src="channels[0].icon" class="channel"/>
          <div>{{channels[0].name}}</div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>

  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';
  import channels from '../../../constant/channels'
  import click_handler from '../../../tools/mgtv/click'
  import {toSign} from '../../../api/tryUse'
  import get_param from '../../../tools/param'

  export default create({
    name: 'TryUseChannelDialog',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      product_id: {
        type: Number,
        default: 0
      },
      days: {
        type: Number,
        default: 0
      }
    },
    methods: {
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      },
      click_close() {
        click_handler('0元试用弹窗-关闭', () => {
          this.handleAction('confirm');
        }, {
          need_login: true,
          need_act: true,
          need_vip: false
        })
      },
      click_channel(channel) {
        click_handler('0元试用弹窗-点击渠道' + channel, () => {
          if(this.days === 0 || this.product_id === 0){
            console.error("days or product_id is zero!")
            return;
          }
          this.handleAction('confirm');
          toSign(channel, this.product_id);
        }, {
          need_login: true,
          need_act: true,
          need_vip: false
        })
      }
    },
    computed: {
      ruler() {
        let ruler = `<div class="title">免费尊享${this.days}天温馨提示</div>
        <p>参加本活动，需开通自动续费服务：</p>
        <p><span>1.</span>免费${this.days}天到期后可享受15元/月自动续费优惠（原价20元）；</p>
        <p><span>2.</span>连续包月开通后，可随时取消;</p>
        <p><span>3.</span>活动仅限新用户，请确保您的<span class="strong">支付账户</span>从未购买过会员或者未参与过同类型活动。</p>`;
        return ruler;
      },
      channels() {
        if (window.gact.is_app) {
          if (window.gact.is_android) {
            // return [{
            //   icon: "//vipcdn.mgtv.com/upload/20180529/shouchong/alipay.png",
            //   channel: channels.alipay.renew,
            //   name: '支付宝支付',
            // }]
            return [
              {
                icon: '//vipcdn.mgtv.com/upload/20180529/shouchong/wechat.png',
                channel: channels.wechat.renew,
                name: '微信支付'
              },
              {
                icon: "//vipcdn.mgtv.com/upload/20180529/shouchong/alipay.png",
                channel: channels.alipay.renew,
                name: '支付宝支付',
              }
            ]
          }
        } else {
          if (window.gact.is_wx) {
            return [{
              icon: "//vipcdn.mgtv.com/upload/20180529/shouchong/wechat.png",
              channel: channels.wechat.renew,
              name: '微信支付'
            }]
          } else {
            return [
              // {
              //   icon: "//vipcdn.mgtv.com/upload/20180529/shouchong/wechat.png",
              //   channel: channels.wechat.renew,
              //   name: '微信支付'
              // },
              {
                icon: '//vipcdn.mgtv.com/upload/20180529/shouchong/alipay.png',
                channel: channels.alipay.renew,
                name: '支付宝支付'
             }
            ]
          }
        }
        return []
      }
    }
  });
</script>


<style lang="stylus">

  .channel-modal
    position: fixed;
    width 6.5rem
    left 50%
    top 50%
    background white
    transform translate(-50%, -50%)
    padding .5rem .4rem .3rem .4rem
    border-radius .2rem

    .close
      position absolute
      top 0
      right 0
      padding .25rem
      color gray

  .title
    font-size .36rem
    margin-bottom .4rem
    color #252420
    font-weight bold
    text-align center

  .content
    p
    span
      font-size .3rem
      color #5f5f5f
      line-height .48rem
      word-break break-all

  .strong
    color #fd7a1a !important
    font-weight bold

  .channel_box
    div
    p
    span
      font-size .3rem
      color #5f5f5f
      line-height .48rem
    .title
      display flex
      align-items center
      text-align center
      justify-content space-around
      margin-top .28rem
      .line
        border-bottom 1px solid #ededed
        width 1.2rem
        height 1px
        text-align center
      span
        font-size .3rem
        color #5f5f5f
        font-weight bold
    .channels
      display flex
      justify-content space-around

    .single_channel
      display flex
      text-align center
      justify-content center

    .channel_item
      width 1.5rem
      display flex
      flex-direction column
      position relative
      align-items center
      div
        padding-top .05rem
        text-align center
        font-size .24rem
        color #999

    .channel
      width 1rem
      height 1rem


</style>



// WEBPACK FOOTER //
// src/components/Popups/TryUseChannelDialog/TryUseChannelDialog.vue